import { StyledForm } from "./Form.styled";

export const AddQuoteForm = () => {
  return <StyledForm></StyledForm>;
};
